import { createAsyncThunk } from "@reduxjs/toolkit";
import { ApiResponse } from "../../../types/APIResponse";
import api from "../../../utils/constants/api";
import { apiEndpoints } from "../../../utils/constants/apiEndpoints";
import { Ship } from "../../../types";
import { DeleteShips } from "./shipSlice";

// Async Thunks
export const fetchShips = createAsyncThunk<Ship[], void, { rejectValue: string }>("ships/fetchShips", async (_, { rejectWithValue }) => {
  try {
    const response = await api.get<ApiResponse<Ship[]>>(apiEndpoints.ship.getAll);
    if (response?.success) {
      return response.data;
    } else {
      throw new Error(response.message || "Failed to fetch ships.");
    }
  } catch (error: any) {
    return rejectWithValue(error.response?.data?.message || error.message);
  }
});
export const createShip = createAsyncThunk<Ship, Ship, { rejectValue: string }>("ships/createShip", async (newShipData, { rejectWithValue }) => {
  try {
    const response = await api.post<ApiResponse<Ship>>(apiEndpoints.ship.create, { data: newShipData });
    if (response?.success) {
      return response.data;
    } else {
      throw new Error(response.message || "Failed to add ship.");
    }
  } catch (error: any) {
    return rejectWithValue(error.message);
  }
});

export const deleteShips = createAsyncThunk<DeleteShips, { id: string }, { rejectValue: string }>("ships/deleteShip", async ({ id }, { rejectWithValue }) => {
  try {
    const response = await api.delete<ApiResponse<DeleteShips>>(`${apiEndpoints.ship.delete}/${id}`);
    if (response?.success) {
      return { ...response.data, id };
    } else {
      throw new Error(response.message || "Failed to delete ship.");
    }
  } catch (error: any) {
    return rejectWithValue(error.message);
  }
});

export const updateShip = createAsyncThunk<Ship, Ship, { rejectValue: string }>("ships/updateShip", async (updatedShipData, { rejectWithValue }) => {
  try {
    const response = await api.put<ApiResponse<Ship>>(`${apiEndpoints.ship.update}/${updatedShipData?.id}`, { data: updatedShipData });
    if (response?.success) {
      return { ...response.data };
    } else {
      throw new Error(response.message || "Failed to update ship.");
    }
  } catch (error: any) {
    return rejectWithValue(error.message);
  }
});
